function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import omit from 'lodash/omit';
import startsWith from 'lodash/startsWith';
import history from 'helpers/history';
import { isMobileDisplayMode as isMobileDisplayModeSelector } from 'modules/App/selectors';
const isExternal = (to)=>startsWith(to, 'http') || startsWith(to, '//');
const isLeftClickEvent = (evt)=>!!evt && evt.button === 0;
const isModifiedEvent = (evt)=>!!(evt && (evt.metaKey || evt.altKey || evt.ctrlKey || evt.shiftKey));
const handleClick = (evt, { to, isReplace, pathState, onClick })=>{
    if (onClick) {
        onClick(evt);
    }
    if (isModifiedEvent(evt) || !isLeftClickEvent(evt)) {
        return;
    }
    if (evt.defaultPrevented === true) {
        return;
    }
    if (isExternal(to)) {
        return;
    }
    evt.preventDefault();
    if (isReplace) {
        history.replace(to, pathState);
        return;
    }
    history.push(to, pathState);
};
const toMobileSuportLink = (to)=>`${to}?display_mode=mobile&from=${encodeURIComponent(window.location.href)}`;
const Link = (props)=>{
    const _omit = omit(props, [
        'isReplace',
        'pathState'
    ]), { children } = _omit, attr = _object_without_properties(_omit, [
        "children"
    ]);
    let { to } = props;
    const onClick = (evt)=>handleClick(evt, props);
    // TODO: This logic shouldn't be here!
    const isMobileDisplayMode = useSelector(isMobileDisplayModeSelector);
    if (isMobileDisplayMode && isExternal(to) && to.startsWith('https://support.glucocontro.online')) {
        to = toMobileSuportLink(to);
        attr.target = '_self';
    }
    return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({
        href: to
    }, attr), {
        onClick: onClick,
        children: children
    }));
};
export default Link;
